<template>
  <div v-if="selectedItem">
    <h6 class="primaryBg whiteText rounded p-2 mb-2">
      Parts Selected
    </h6>
    <div class="selectedModalParts">
      <div class="row">
        <div
          v-for="(item, index) in selectedItem.parts"
          :key="index"
          class="col-lg-6 col-md-6 col-sm-6 col-12"
        >
          <div class="partsCard p-2 rounded">
            <h6 class="secondarybg whiteText p-2 rounded mb-2">
              {{ item.part_name }}
            </h6>
            <div class="partsDet pt-3">
              <p class="mb-3 blackText">
                Category:
                <span
                  v-if="!bookingResponse.is_flat_price_model"
                  class="orangeText"
                > {{ item.category_name }}</span>
                <span
                  v-else
                  class="orangeText"
                > Component</span>
              </p>
              <div
                class="quantity d-flex justify-content-between align-items-center mb-3"
              >
                <h6 class="mb-0 blackText">
                  Quantity
                </h6>
                <div class="product-count">
                  <button
                    class="button-count secondarybg"
                    :disabled="item.quantity == 1 || item['is_warranty'] == 1 || bookingResponse.is_flat_price_model"
                    @click="decrement(item)"
                  >
                    -
                  </button>
                  <input
                    type="text"
                    readonly
                    class="number-product rounded"
                    :value="item.quantity"
                  >
                  <button
                    class="button-count primaryBg"
                    :disabled="item.quantity === 10 || item['is_warranty'] == 1 || bookingResponse.is_flat_price_model"
                    @click="increment(item)"
                  >
                    +
                  </button>
                </div>
              </div>
              <div
                class="pertPrice d-flex justify-content-between align-items-center mb-1 relative"
              >
                <h6 class="mb-0 blackText">
                  {{
                    item.is_special
                      ? "Special Part Price Per Unit:"
                      : "Part Price Per Unit:"
                  }}
                </h6>
                <input
                  v-model="item.cost_with_markup"
                  inputmode="decimal"
                  type="text"
                  :disabled="item['is_warranty'] == 1"
                  size="4"
                  class="form-control mb-0 lightGreyBg rounded orangeText text-center"
                  @paste="disablePaste"
                  @keypress="isNumber($event)"
                  @input="isNumber($event)"
                >
              </div>
              <div class="flex justify-end min-h-[20px] w-full">
                <span class="text-[11px] text-red-500" v-if="item.is_max_markup_applicable && item.cost_with_markup > item.max_allowed_price">Price cannot exceed ${{ item.max_allowed_price }}.</span>
              </div>
              <div class="form-group">
                <h6 class="mb-3 blackText">
                  Is this part being replaced under:
                </h6>
                <div class="form-check d-flex p-0">
                  <div class="form__checkbox d-flex align-items-center me-5">
                    <input
                      :id="selectedItem.diagnostic_option_id + '-' + index"
                      v-model="item['is_warranty']"
                      type="checkbox"
                      name="check"
                      :disabled="bookingResponse.is_flat_price_model"
                      @change="handleClick(item)"
                    >
                    <label
                      class="blueText"
                      :for="selectedItem.diagnostic_option_id + '-' + index"
                      :disabled="bookingResponse.is_flat_price_model"
                    >Part Warranty</label>
                  </div>
                </div>
                <a
                  v-if="!bookingResponse.is_flat_price_model"
                  class="removeCard"
                  @click="removeItem(item)"
                >
                  <img
                    src="../../assets/images/delete-fill-icon.png"
                    alt="delete-icon"
                    class="mx-auto d-table mt-3"
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomButtons d-flex justify-content-center mt-5">
      <button
        class="modalBtn buttonPrimary d-flex align-items-center text-uppercase me-2"
        @click="closeButtonClicked()"
      >
        Cancel
      </button>
      <button
        :class="'modalBtn buttonSecondary d-flex align-items-center text-uppercase ' + (isAnyItemSlected ? 'disabled' : '') "
        :disabled="isAnyItemSlected"
        @click="saveButtonClicked()"
      >
        Save
      </button>
    </div>
  </div>
</template>
<script>
import {  mapGetters } from "vuex";

import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  props: ["item"],
  data() {
    return {
      selectedItem: null,
    };
  },

  computed: {
    ...mapGetters([
      "bookingResponse"
    ]),
    isAnyItemSlected() {
      return (this.selectedItem.parts && this.selectedItem.parts.length > 0 )? false : true;
    }
  },

  watch: {
    item: function () {
      this.selectedItem = this.item;
    },
  },

  mounted() {},

  methods: {
    saveButtonClicked() {
      let res = true;
      let msg = "";
      this.selectedItem.parts.forEach((element) => {
        if (!element["is_warranty"] && element.cost_with_markup.length <= 0) {
          msg = "Price field is required.";
          res = false;
        }
      });

      const hasError = this.selectedItem.parts.some(item => {
        return (
          item.is_max_markup_applicable &&
          item.cost_with_markup > item.max_allowed_price
        )
      })

      if (hasError) {
        msg = "Please fix price errors before saving";
        res = false;
      }

      if (res) {
        this.$emit("event", "save");
      } else {
        toast.error(msg);
      }
    },

    closeButtonClicked() {
      this.$emit("event", "close");
    },

    decrement(data) {
      if (data.quantity > 1) {
        data.quantity--;
      }
    },
    increment(data) {
      if (data.quantity < 10) {
        data.quantity++;
      }
    },

    handleClick(data) {
      if (data.is_warranty) {
        data.cost_with_markup = "0";
        data.quantity = "1";
      }
    },

    removeItem(data) {
      this.selectedItem.parts = this.selectedItem.parts.filter(function (item) {
        return item !== data;
      });
    },

    disablePaste(event) {
      event.preventDefault();
    },

    isNumber(evt) {
  const inputElement = evt.target;
  let value = inputElement.value;

  if (evt.type === 'input') {
    // Remove non-numeric and multiple decimal points
    value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const [integer, decimal] = value.split('.');

    // Restrict integer part to 5 digits
    if (integer.length > 5) value = integer.slice(0, 5);

    // Restrict decimal part to 2 digits
    if (decimal) {
      if (integer === "") {
        value = "";
      } else {
        value = `${integer}.${decimal.slice(0, 2)}`;
      }
    }

    // Prevent starting with '.'
    if (value.startsWith('.') || value === '') {
      value = '';
    }

    inputElement.value = value;
    inputElement.dispatchEvent(new Event('input', { bubbles: true }));

  } else if (evt.type === 'keypress') {
    const charCode = evt.which || evt.keyCode;

    // Allow backspace, delete, tab, numbers (0-9), and a single '.'
    if (charCode === 8 || charCode === 46 || charCode === 9 || (charCode >= 48 && charCode <= 57)) {
      if (charCode === 46 && value.indexOf('.') !== -1) {
        evt.preventDefault();
        return false;
      }
      return true;
    }
    evt.preventDefault();
    return false;
  }
}
  },
};
</script>

<style>
.removeCard img {
  width: 30px;
  height: 30px;
}

div#selectPartModal .modal-dialog {
  height: 70vh;
}
.product-count button:disabled {
  background-color: silver;
  border: 1px solid #ccc;
  color: #ccc;
  background: transparent;
}
input[disabled] {
  border-color: #ccc !important;
}
label[disabled] {
  color: #ccc !important;
}
</style>
